import axios from 'axios';

export interface WebsiteCategoryApiItem {
  id?: string;
  uuid?: string;
  name?: string;
  slug?: string;
  description?: string;
  image?: string;
  status?: boolean;
}

export interface WebsiteCategory {
  id: string;
  uuid: string;
  name: string;
  slug: string;
  description: string;
  image: string;
}

export interface WebsiteSubcategoryApiItem {
  uuid?: string;
  categoryUuid?: string;
  name?: string;
  slug?: string;
  image?: string;
  displayOrder?: number;
}

export interface WebsiteSubcategory {
  uuid: string;
  categoryUuid: string;
  name: string;
  slug: string;
  image: string;
}

const websiteApiBaseUrl = (import.meta.env.VITE_WEBSITE_API_BASE_URL || 'https://api.beautysports.in/website-api').replace(/\/$/, '');
const websiteAssetBaseUrl = websiteApiBaseUrl.replace(/\/website-api$/, '');

function slugify(value: string) {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function resolveImageUrl(image?: string) {
  if (!image) return '';
  if (/^https?:\/\//i.test(image)) return image;
  if (image.startsWith('/uploads')) return `${websiteAssetBaseUrl}${image}`;
  return image;
}

function mapSubcategory(item: WebsiteSubcategoryApiItem): WebsiteSubcategory {
  const name = item.name || 'Subcategory';

  return {
    uuid: item.uuid || slugify(name),
    categoryUuid: item.categoryUuid || '',
    name,
    slug: item.slug || slugify(name),
    image: resolveImageUrl(item.image),
  };
}

function mapCategory(item: WebsiteCategoryApiItem): WebsiteCategory {
  const name = item.name || 'Category';

  return {
    id: item.id || item.uuid || slugify(name),
    uuid: item.uuid || item.id || slugify(name),
    name,
    slug: item.slug || slugify(name),
    description: item.description || '',
    image: resolveImageUrl(item.image),
  };
}

export async function getWebsiteCategories(): Promise<WebsiteCategory[]> {
  const response = await axios.get<{ data: WebsiteCategoryApiItem[] }>(`${websiteApiBaseUrl}/categories`);
  return (response.data.data || []).map(mapCategory).filter((category) => category.name && category.image);
}
export async function getWebsiteSubcategories(categoryUuidOrSlug: string): Promise<WebsiteSubcategory[]> {
  const response = await axios.get<{ data: WebsiteSubcategoryApiItem[] }>(`${websiteApiBaseUrl}/categories/${encodeURIComponent(categoryUuidOrSlug)}/subcategories`);
  return (response.data.data || []).map(mapSubcategory).filter((subcategory) => subcategory.uuid && subcategory.name);
}
